import { isEmpty } from "underscore";

export const getTranslatedText = (
  defaultText: string,
  translations: { [key: string]: string } | undefined,
  selectedLanguage: string
): string => {
  if (!translations || isEmpty(translations)) {
    return defaultText;
  }
  const normalizedLanguage = selectedLanguage.toUpperCase();
  const matchingKey = Object.keys(translations).find((key) => key.toUpperCase() === normalizedLanguage);
  const translatedText = matchingKey ? translations[matchingKey] : undefined;
  return translatedText?.trim() ? translatedText : defaultText;
};
